export default __webpack_public_path__ + "static/media/11.ca03fa9c.jpg";